module.exports = __webpack_public_path__ + "static/media/default.0a3f40ac.svg";